var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.04,257.85H110.96c-7.25,0-13.12-5.88-13.12-13.12v-36.81c0-7.25,5.88-13.12,13.12-13.12h478.09 c7.25,0,13.12,5.88,13.12,13.12v36.81C602.17,251.97,596.29,257.85,589.04,257.85z M589.04,383.9H110.96 c-7.25,0-13.12-5.88-13.12-13.12v-36.81c0-7.25,5.88-13.12,13.12-13.12h478.09c7.25,0,13.12,5.88,13.12,13.12v36.81 C602.17,378.03,596.29,383.9,589.04,383.9z M589.04,509.95H110.96c-7.25,0-13.12-5.88-13.12-13.12v-36.81 c0-7.25,5.88-13.12,13.12-13.12h478.09c7.25,0,13.12,5.88,13.12,13.12v36.81C602.17,504.08,596.29,509.95,589.04,509.95z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburgerMenu.978ab70d3dad72e6d86556a95347840e.svg";
export { ForwardRef as ReactComponent };